angular.module('app').directive('apMobileNav', ['$rootScope', 'SessionService', 'TransitionManager', 'LogOffService',
    function ($rootScope, SessionService, TransitionManager, LogOffService) {
        'use strict';

        return {
            restrict: 'E',
            templateUrl: '/app/partials/mobileNav/views/apMobileNav.html',
            scope: true,
            transclude: false,
            link: function (scope) {

                scope.showMobileNav = SessionService.getShowMobileNav();
                
                scope.headerData = {
                };

                scope.transitionAndCloseNav = function(transition) {
                  TransitionManager.transition(transition);
                  SessionService.setShowMobileNav(false);
                };

                var headerUpdateListener = $rootScope.$on('HeaderData:updated', function(event, data) {
                    if(!(data && (data.requestor || 'apMobileNav') !== 'apMobileNav'))
                        scope.headerData = data;
                });

                scope.signOff = function() {
                    LogOffService.logoff().then(function() {
                        TransitionManager.transition({appRoute: 'login'});
                        SessionService.setShowMobileNav(false);
                    });
                };
                
                scope.setActiveUser = function(personId) {
                    $rootScope.$broadcast('ActiveUser:updated', personId);
                    SessionService.setShowMobileNav(false);
                };

                function loadMobileNav() {
                    $rootScope.$broadcast('HeaderData:requested', 'apMobileNav');
                }
                loadMobileNav();

                var showMobileNavListener = scope.$on('ShowMobileNav:updated', function(event, data) {
                    scope.showMobileNav = data;
                });

                scope.$on('$destroy', function () {
                    showMobileNavListener();
                    headerUpdateListener();
                });
            }
        };
}]);
